import React from 'react';

const Brands = () => {
  const brands = [
    "/assets/brand-logos/1.jpeg",
    "/assets/brand-logos/2.jpeg",
    "/assets/brand-logos/4.jpeg",
    "/assets/brand-logos/3.png",
    "/assets/brand-logos/5.jpeg"
  ];

  return (
    <div>
      <style>
        {`
          @keyframes scroll {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          .marquee-container {
            overflow: hidden;
            padding: 40px 0;
            background: #f8f6f2;
            position: relative;
            width: 100%;
          }

          .marquee-container::before,
          .marquee-container::after {
            content: "";
            height: 100%;
            position: absolute;
            width: 120px;
            z-index: 2;
            pointer-events: none;
            top: 0;
          }

          .marquee-container::before {
            left: 0;
            background: linear-gradient(
              to right,
              #f8f6f2 0%,
              rgba(248, 246, 242, 0) 100%
            );
          }

          .marquee-container::after {
            right: 0;
            background: linear-gradient(
              to left,
              #f8f6f2 0%,
              rgba(248, 246, 242, 0) 100%
            );
          }

          .marquee-track {
            display: flex;
            align-items: center;
            gap: 20px; /* Reduced spacing */
            width: max-content;
            animation: scroll 40s linear infinite;
          }

          .marquee-track:hover {
            animation-play-state: paused;
          }

          .brand-logo-wrapper {
            flex-shrink: 0;
            width: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .brand-logo-img {
            width: 100%;
            max-height: 80px;
            object-fit: contain;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            filter: drop-shadow(0 5px 15px rgba(0,0,0,0.05));
          }

          .brand-logo-wrapper:hover .brand-logo-img {
            transform: scale(1.12);
            filter: drop-shadow(0 10px 20px rgba(0,0,0,0.15));
          }

          .marquee-track div:nth-child(even) .brand-logo-img {
            animation: float 4s infinite ease-in-out;
          }

          .marquee-track div:nth-child(odd) .brand-logo-img {
            animation: float 5s infinite ease-in-out;
          }

          .brand-title {
            font-family: 'Oswald', sans-serif;
            font-weight: 700;
            letter-spacing: 1px;
          }

          .brand-dark {
            color: #000 !important;
          }

          @media (max-width: 768px) {
            .brand-logo-wrapper {
              width: 130px;
            }

            .brand-logo-img {
              max-height: 55px;
            }

            .marquee-track {
              gap: 12px;
            }

            .marquee-container::before,
            .marquee-container::after {
              width: 60px;
            }
          }
        `}
      </style>

      <section style={{ padding: "80px 0", background: "#f8f6f2" }}>
        <div className="container text-center mb-5">
          <h6
            style={{
              color: "#fc7303",
              letterSpacing: "3px",
              fontWeight: "600",
            }}
          >
            AUTHORIZED DEALERS OF
          </h6>

          <h2 className="brand-title brand-dark h1">
            LEADING BRANDS
          </h2>
        </div>

        <div className="marquee-container">
          <div className="marquee-track">
            {[...brands, ...brands, ...brands, ...brands, ...brands].map(
              (logo, index) => (
                <div className="brand-logo-wrapper" key={index}>
                  <img
                    src={logo}
                    alt={`Brand Logo ${index + 1}`}
                    className="brand-logo-img"
                  />
                </div>
              )
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Brands;